import React, { useEffect, useState } from 'react';
import { SelectMultiple } from 'grommet';
import PropTypes from 'prop-types';
import { API } from '../api';
import QueryString from 'qs';
import { Utils } from '../helpers/Utils';
import { buildLocationFilters } from '../helpers/LocationSearch';
// import { Close } from 'grommet-icons';
import { useDebouncedCallback } from 'use-debounce';

const NAME_KEYS = {
    companies: 'name',
    industries: 'name',
    jobs: 'title',
    'job-functions': 'name',
    majors: 'name',
    'technical-skills': 'name',
};

export const ApiOptionsSelect = ({
    contentType,
    defaultValue,
    filters,
    placeholder,
    populate,
    updateFormData,
    value,
}) => {
    const nameKey = NAME_KEYS[contentType] ?? 'name';
    const [searchInput, setSearchInput] = useState('');
    const [searchOptions, setSearchOptions] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState(defaultValue ?? []);

    const debouncedRequest = useDebouncedCallback((input) => {
        handleApiRequest(input);
    }, 300);

    const handleApiRequest = async (input) => {
        if (contentType == 'locations') return handleLocationApiRequest(input);
        const results = await searchContentType(
            contentType,
            nameKey,
            input,
            populate,
            filters,
        );
        const alreadySelectedIds = selectedOptions.map((i) => i.id);

        const formattedResults = results
            .filter((r) => !alreadySelectedIds.includes(r.id))
            .map((r) => {
                return {
                    label: r[nameKey],
                    value: r,
                };
            });
        console.log(results);
        setSearchOptions(selectedOptions.concat(formattedResults));
    };

    const handleLocationApiRequest = async (input) => {
        const results = await searchContentType(contentType, nameKey, input);
        const alreadySelectedIds = selectedOptions.map((i) => i.value.id);
        const formattedResults = results
            .filter((r) => !alreadySelectedIds.includes(r.id))
            .map((r) => {
                const state = r.state ?? '?';
                return {
                    name: `${r[nameKey]}, ${state}`,
                    value: r,
                };
            });
        setSearchOptions(selectedOptions.concat(formattedResults));
    };

    const handleChange = ({ value }) => {
        setSelectedOptions(value);
        updateFormData(value.map((v) => v.value));
    };

    const handleSearch = (input) => {
        setSearchInput(input);
    };

    const resetSearch = () => {
        setSearchOptions(selectedOptions);
    };

    useEffect(() => {
        if (!searchInput.length) {
            setSearchOptions(selectedOptions);
            return;
        }

        debouncedRequest(searchInput);
    }, [searchInput]);

    useEffect(() => {
        // for when selection is supplied from parent element
        if (searchOptions.length == 0) {
            setSearchOptions(value);
        }
    }, [value]);

    return (
        <SelectMultiple
            // key={labelKey}
            placeholder={placeholder}
            defaultValue={defaultValue}
            // labelKey={nameKey}
            searchPlaceholder="Search options..."
            options={searchOptions || []}
            onChange={handleChange}
            onClose={resetSearch}
            onSearch={handleSearch}
            showSelectedInline={true}
            value={value}
        />
    );
};

async function searchContentType(
    contentType,
    nameKey,
    input,
    populate,
    filters = {},
) {
    const searchFilters =
        contentType === 'locations'
            ? { ...filters, ...buildLocationFilters(input) }
            : { ...filters, [nameKey]: { $containsi: input } };

    const query = QueryString.stringify({
        filters: searchFilters,
        pagination: {
            limit: 5,
        },
        populate: populate,
    });

    try {
        const response = await API.get(`/api/${contentType}?${query}`);
        return Utils.deepFlatten(response.data);
    } catch (error) {
        console.log(error);
        return [];
    }
}

ApiOptionsSelect.propTypes = {
    contentType: PropTypes.string,
    defaultValue: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    filters: PropTypes.object,
    placeholder: PropTypes.string,
    populate: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    selectMultiple: PropTypes.bool,
    updateFormData: PropTypes.func,
    value: PropTypes.array,
};
